<template>
  <div class="main-container">
    <div class="form-confirm">
      <div style="display: flex; justify-content: center; margin-bottom: 10px">
        <img alt="Atosa"
             style="width:80px; height:80px; background-color:white; border-radius: 50vh; padding:3px !important;"
             src="/static/img/logo.png"/>
      </div>
      <div style="text-align: center; padding: 0 10px">
        <strong style="text-transform: uppercase; font-size: 18px; color: #125570;">
          {{ $t('base.forgot_password') }}?
        </strong>
      </div>
      <div style="margin-top: 30px">
        <form @submit="m__send_forgot_password">
          <div style="margin-top: 10px">
            <strong style="font-size: 14px">{{ $t('base.sent_password_request_message') }}.
            </strong>
          </div>
          <div style="margin-top: 20px">
            <p style="font-size: 14px; font-weight: 600; color: #041722; margin-bottom: 5px">
              {{ $t('base.email_address') }}
            </p>
            <el-input v-model="email" :placeholder="$t('input.email_address')"></el-input>
          </div>

          <div style="margin-top: 30px">
            <el-button type="summit" class="full-w" :loading="loading" @click="m__send_forgot_password">
              {{ $t('base.send_request') }}
            </el-button>
          </div>

          <div style="margin-top: 35px; text-align: center">
            <a href="javascript:void(0)" @click="$router.push('/login')">
              <strong style="font-size: 14px" class="text-primary">< {{ $t('base.back_to_login') }}</strong>
            </a>
          </div>

          <button type="submit" style="display: none;"/>
        </form>
      </div>
    </div>

    <div class="info-container">
      <div>
        <strong>{{ $t('base.join_shopee_ads_course') }} </strong>
        <a href="https://www.quangcaoshopee.com" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
      <div>
        <strong> {{ $t('base.learn_about_atosa') }}</strong>
        <a href="https://atosa.asia" target="_blank" class="text-primary">{{ $t('base.here') }}</a>
      </div>
    </div>

    <el-dialog width="800px" :close-on-click-modal="false" :visible.sync="success_dialog"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <div style="text-align: center; margin-top: 30px">
          <strong style="font-size: 18px; color: tomato">
            {{ $t('base.send_request_password_success') }}
          </strong>
        </div>
        <div style="text-align: center; margin-top: 10px">
          <strong style="font-size: 14px;">
            {{ $t('base.send_request_password_success_message') }}.
          </strong>
        </div>
        <div style="text-align: center; margin-top: 25px">
          <el-button type="primary" class="summit-button" @click="m__confirm_send_successfully">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'confirm-page',

  data() {
    return {
      email: '',
      recaptcha_response: '',
      loading: false,
      success_dialog: false
    }
  },

  // beforeCreate () {
  //   if (typeof this.$store.state.userInfo.username !== 'undefined') this.$router.push('/')
  // },

  methods: {
    m__confirm_send_successfully() {
      this.success_dialog = false

      if (this.$route.query.redirect_url) {
        window.location.href = this.$route.query.redirect_url
      } else {
        window.location.href = '/'
      }
    },

    async m__reload_recaptcha() {
      this.recaptcha_response = await this.m__get_recaptcha_token()
    },

    m__get_recaptcha_token() {
      return new Promise(resolve => {
        grecaptcha.ready(async () => {
          const token = await grecaptcha.execute('6Lf3isIaAAAAAEEx5IBmKbf0Zdef-jGA8unA2XdB', {action: 'validate_captcha'})
          resolve(token)
        })
      })
    },

    async m__send_forgot_password(e) {
      e.preventDefault()

      if (!this.email) {
        this.ntf_w(this.$t('required.email_address'))
        return
      }

      await this.m__reload_recaptcha()
      if (!this.recaptcha_response) {
        this.ntf_w(this.$t('required.captcha'))
        return
      }

      this.loading = true
      const form = {
        email: this.email,
        captcha: this.recaptcha_response,
        response: this.recaptcha_response,
        captcha_version: 'v3',
        channel: 'Atosa',
        redirect_url: `${window.location.origin}/forgot-password/verify?redirect_url=${this.$route.query.redirect_url || '/'}&token=`
      }

      try {
        await this.$http.post(`https://api.atosa.asia/api/input/sign/forgot-password`, form)
        this.success_dialog = true
      } catch (e) {
        this.ntf_w(e)
      } finally {
        await this.m__reload_recaptcha()
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.main-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-image: url("/static/img/Group 483x3.png");
  //background-position-x: -10px;
  background-position-y: -60px;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.form-confirm {
  width: 430px;
  position: absolute;
  top: 10%;
  //top: 50%;
  //transform: translate(0, -50%);
  //right: 130px;
  right: 8%;
  padding: 25px 30px;
  margin: auto;

  background: #FFFFFF;
  box-shadow: 0 2px 22px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

.info-container {
  width: 100%;
  position: absolute;
  bottom: 0;
  text-align: center;
  padding: 0 0 15px;

  div strong {
    font-size: 13px;
    color: #041722;
    line-height: 30px;
  }

  div a {
    font-size: 13px;
    line-height: 30px;
    font-weight: bold;
  }
}

@media screen and (min-width: 1600px) {
  .form-confirm {
    top: 18%;
    right: 13%;
  }
}

@media screen and (min-width: 1900px) {
  .form-confirm {
    top: 18%;
    right: 13%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/forgot/confirm.vue